import { toArray } from '@eastcoal/common/utils/array'

import { SchemaItem } from '../interface'

export const isReqiredField = (schema: SchemaItem) => {
  return (
    schema.required ||
    toArray(schema['x-validator']).some(rule => rule.required)
  )
}
